import PatientNextAttendancesContainer from "./PatientNextAttendancesContainer";

export default PatientNextAttendancesContainer;
